import { ReactElement, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useMutation, gql } from '@apollo/client'
import styled from 'styled-components'

import Dropdown from 'components/v2/Dropdown'
import List from 'components/v2/List'
import { DotsIcon } from 'components/Icons/DotsIcon'
import { WarningIcon } from '@10xLabs/react-web/components/Icons/Warning'
import { GTVehicleTemplate } from 'gql/types.generated'
import IconButton from 'components/v2/IconButton'

const ArchiveVehicleTemplateWrapper = styled.div`
  display: flex;
  align-items: center;
`

const StyledWarningIcon = styled(WarningIcon)`
  margin-left: 10px;
`

const ARCHIVE_VEHICLE_TEMPLATE = gql`
  mutation ArchiveVehicleTemplate($id: ID!) {
    archiveVehicleTemplate(input: { id: $id })
  }
`

interface IVehicleTemplatesActionsProps {
  vehicleTemplate: GTVehicleTemplate
  refetch: () => void
}
export const VehicleTemplatesActions = ({ vehicleTemplate, refetch }: IVehicleTemplatesActionsProps): ReactElement => {
  const [isOpenDropdown, setOpenDropdown] = useState(false)

  const toggleDropdown = (): TSFixMe => {
    setOpenDropdown(!isOpenDropdown)
  }

  const [archiveVehicleTemplate, { loading, error }] = useMutation(ARCHIVE_VEHICLE_TEMPLATE, {
    onCompleted() {
      setOpenDropdown(false)
      refetch()
    }
  })

  return (
    <>
      <Dropdown.Wrapper noPadding noIndicator onClickAway={(): void => setOpenDropdown(false)}>
        <IconButton icon={<DotsIcon />} onClick={toggleDropdown} noBorder smallPadding />
        <Dropdown.Content open={isOpenDropdown} noIndicator left>
          <List.Container>
            <List.Item noPadding>
              <List.Link to={`/vehicle-templates/${vehicleTemplate.id}`}>
                <FormattedMessage id="vehicleTemplates.list.actions.edit" defaultMessage="Edit template" />
              </List.Link>
            </List.Item>
            <List.Item
              action
              onClick={(): void => {
                archiveVehicleTemplate({
                  variables: {
                    id: vehicleTemplate.id
                  }
                })
              }}
              loading={loading}
            >
              <ArchiveVehicleTemplateWrapper>
                <FormattedMessage id="dictionary.archive" defaultMessage="Archive" />
                {error && <StyledWarningIcon />}
              </ArchiveVehicleTemplateWrapper>
            </List.Item>
          </List.Container>
        </Dropdown.Content>
      </Dropdown.Wrapper>
    </>
  )
}
